export const pageDefaultTitle = '探鲸';
// 微信小程序AppId
export const wxAppId = 'wx34b3eb85f2615941';
export const wxAppHomePagePath = 'pages/index/index';
export const wxAppBecomeReferrerPath = 'pages-referrer/become-referrer';
// 发通告页（推荐官分享-给PR 落地）
export const wxAppPublishPath = 'pages/pub/index';
export const wxNoticeDetailPagePath = 'pages/detail/notice-detail';
export const wxTungeaNoticeDetailPagePath = 'pages-task/tungea-notice-detail';
/** 发单者主页（与小程序 pages-task/pr-info 对齐） */
export const wxPrInfoPagePath = 'pages-task/pr-info';
export const wxAppOriginalId = 'gh_e0164c307d07';

// 公众号URL
export const GZH_URL = 'https://mp.weixin.qq.com/s/EzHHhrZRBBV6eWuGySJonw';
